import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OrderSelectItemSearchCriteria } from '@shared/models/order-request.model';
import { TdAssortmentListPagination } from '@shared/models/purchase-request.model';

import { MetricActionType, MetricModule, MetricType, Metrics } from '../models/metrics';
import { BaseService } from './base.service';

@Injectable()
export class ProductAssortmentPimService extends BaseService {
  public headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.assortmentPim;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public searchSelectiveCatalogByCriteria(criteria: OrderSelectItemSearchCriteria): Observable<any> {
    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.RESPONSE_TIME,
          module: MetricModule.PRODUCT,
          route: this.envService.url,
          action: MetricActionType.SEARCH
        }
      ]
    };
    const params = this.getParams({
      ...criteria,
      productType: criteria.productType.toString()
    });
    const url = this.getFullUrl(this.envService.catalogs);

    return this.http.get<TdAssortmentListPagination>(url, {
      headers: this.loaderHeaders(null, metricsReq),
      observe: 'body',
      params
    });
  }

  public searchStockProductListSelectiveCatalogByCriteria(criteria: OrderSelectItemSearchCriteria): Observable<any> {
    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.RESPONSE_TIME,
          module: MetricModule.PRODUCT,
          route: this.envService.url,
          action: MetricActionType.SEARCH
        }
      ]
    };
    const params = this.getParams({
      ...criteria,
      sortBy: ['productName.en_sort', 'articleNo.sort'].toString(),
      sortOrder: 'asc',
      wmsCode: criteria.wmsCode
    });
    const url = this.getFullUrl(this.envService.catalogs);

    return this.http.get<TdAssortmentListPagination>(url, {
      headers: this.loaderHeaders(null, metricsReq),
      observe: 'body',
      params
    });
  }

  public searchStoreUseCatalogByCriteria(criteria: OrderSelectItemSearchCriteria): Observable<any> {
    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.RESPONSE_TIME,
          module: MetricModule.PRODUCT,
          route: this.envService.url,
          action: MetricActionType.SEARCH
        }
      ]
    };
    const params = this.getParams({
      ...criteria,
      productType: criteria.productType.toString()
    });
    const url = this.getFullUrl(this.envService.catalogs);

    return this.http.get<TdAssortmentListPagination>(url, {
      headers: this.loaderHeaders(null, metricsReq),
      observe: 'body',
      params
    });
  }

  public searchCatalogByCriteria(criteria: OrderSelectItemSearchCriteria): Observable<any> {
    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.RESPONSE_TIME,
          module: MetricModule.PRODUCT,
          route: this.envService.catalogs,
          action: MetricActionType.SEARCH
        }
      ]
    };
    const params = this.getParams({
      ...criteria,
      productType: criteria.productType.toString()
    });
    const url = this.getFullUrl(this.envService.catalogs);

    return this.http.get<TdAssortmentListPagination>(url, {
      headers: this.loaderHeaders(null, metricsReq),
      observe: 'body',
      params
    });
  }

  public searchFirstLotCatalogByCriteria(criteria: OrderSelectItemSearchCriteria): Observable<any> {
    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.RESPONSE_TIME,
          module: MetricModule.PRODUCT,
          route: this.envService.url,
          action: MetricActionType.SEARCH
        }
      ]
    };
    const params = this.getParams({
      ...criteria,
      productType: criteria.productType.toString()
    });
    const url = this.getFullUrl(this.envService.catalogs);

    return this.http.get<TdAssortmentListPagination>(url, {
      headers: this.loaderHeaders(null, metricsReq),
      observe: 'body',
      params
    });
  }
}
